import { createAsyncThunk } from '@reduxjs/toolkit';
import { getToken } from '../../Utils/authUtils';
import { _expressUrls } from '../../constant';

export interface GetImageUrlsPayload {
  studyUID: string;
}

export const getImageUrlsApi = createAsyncThunk(
  'express/getImageUrls',
  async (payload: GetImageUrlsPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      
      if (!token) {
        return rejectWithValue('No token found');
      }

      const response = await fetch(_expressUrls.GET_IMAGE_URLS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        redirect: 'follow',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || `HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
